import React from 'react';

export default function Alert ({type='info', children=null}) {
    return (
        <div className={`alert alert-${type}`}>
            {children}
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/js/components/alert.js